export enum explanationIds {
    initialDisplay = 'initial/display',
    initialSelectSite = 'initial/select-site',
    siteSelectionPick = 'site-select/pick',
    siteSelectionData = 'site-select/data',
    siteDrawDraw = 'site-draw/draw',
    siteDrawAccept = 'site-draw/accept',
    buildingAdd = 'building/add',
    buildingSelectType = 'building/select-type',
    buildingLivingMix = 'building/living-mix',
    buildingNavigation = 'building/navigation',
    buildingDetails = 'building/details',
    buildingEdit = 'building/edit',
    buildingEdit3d = 'building/edit-3d',
    introFinish = 'intro/finish',
}

export class Ftue {
    explanationsSkipAll?: boolean;
    explanationsFinished?: explanationIds[];
}

export class UserPrivateData {
    roles: roles[];
    userId: string;
    name: string;
    surname: string;
    addition?: string;
    company?: string;
    phone?: string;
    email: string;
    agreeToTermsAndConditionsAndPrivacy: boolean;
    agreeToReceiveEmailsWithNewsAndOffers: boolean;
    lastEdit: any;
}

export class UserPublicData {
    //This might be visible to other users
    publicName: string;
    userId: string;
    lastEdit: any;
}

export class UserData {
    public: UserPublicData;
    private: UserPrivateData;
}

export enum roles {
    standard = 'standard',
    admin = 'admin',
}